import DireccionService from "common/services/DireccionService"
import "leaflet/dist/leaflet.css"
import { nanoid } from "nanoid"
import { useEffect, useState } from "react"
import { MapContainer, Marker, TileLayer, Tooltip } from "react-leaflet"
import Spinner from "../../../Spinner/Spinner"
import { LocationIcon, REACT_MAP_SOURCE } from "../../constants"

import "./style.scss"

const MapComponent = ({
  postalCode,
  address,
  className = "",
}: $TSMigrationFixMe) => {
  const [data, setData] = useState()
  const [loading, setLoading] = useState(false)
  const [coordinates, setCoordinates] = useState({ lat: "", lng: "" })

  const findCoordinates = () => {
    if (postalCode) {
      setLoading(true)
      DireccionService.getMapCoordinates(postalCode)
        .then((response) => {
          setData(response?.data)
          setCoordinates({
            lat: response?.data?.[0]?.lat || "",
            lng: response?.data?.[0]?.lon || "",
          })
        })
        .finally(() => setLoading(false))
    }
  }

  useEffect(() => {
    findCoordinates()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [postalCode])

  return (
    <div
      className={`map_container d-flex justify-content-center align-items-center ${className}`}
    >
      {loading ? (
        <Spinner
          simple
          small
          onlySpinner
        />
      ) : (
        <MapContainer
          // @ts-expect-error TS(2322): Type '{ lat: string; lng: string; }' is not assign...
          center={coordinates}
          zoom={12}
          key={nanoid()}
        >
          <TileLayer
            url={REACT_MAP_SOURCE}
            attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
          />
          {/* @ts-expect-error TS(2339): Property 'length' does not exist on type 'never'. */}
          {data && data?.length && (
            <Marker
              // @ts-expect-error TS(2322): Type '{ lat: string; lng: string; }' is not assign...
              position={coordinates}
              icon={LocationIcon}
            >
              <Tooltip>{address}</Tooltip>
            </Marker>
          )}
        </MapContainer>
      )}
    </div>
  )
}

export default MapComponent
